// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3YmtD","buttons":"Footer_buttons__2R7yV"};